import { AntModal } from './styles'

export default AntModal